const FALLBACK_LANG = "EN"
const FALLBACK_COUNTRY = "XX"
// const API_URL = "http://localhost:8000/v1/"
const API_URL = "https://base-api.devect.com/v1/"
const GEOLOCATION_URL = "https://geo.cocunat.workers.dev"

const LOCATIONS = {
    "AMS": "466a409d-f096-4764-b534-9eed95fdf8c2",
    "US-WEST": "e7216120-187a-4a23-85ed-e8ecc6723e45",
    "US-EAST": "0b6e54df-80d7-46e4-925d-f75467c23516"
}

const INTERVAL_TO_TEXT = {
    "1": "Every 1 min",
    "2": "Every 5 min",
    "3": "Every 15 min",
    "4": "Every 30 min",
    "5": "Every 1 hour",
    "6": "Every 12 hours",
    "7": "Every 24 hours",
}

const METHOD_TO_TEXT = {
    "0": "GET",
    "1": "POST",
    "2": "PUT",
    "3": "PATCH",
    "4": "DELETE",
    "5": "COPY",
    "6": "HEAD",
    "7": "OPTIONS",
    "8": "LINK",
    "9": "UNLINK",
    "10": "PURGE",
    "11": "LOCK",
    "12": "UNLOCK",
    "13": "PROPFIND",
    "14": "VIEW",
}

const RATIO_WARNING = 99.85


const PLANS_LIMITATIONS = {
    0: {
        interval: 99999999999,
        testcases: 0
    },
    572802: {
        interval: 3,
        testcases: 5
    },
    572803: {
        interval: 1,
        testcases: 25
    },
    572804: {
        interval: 1,
        testcases: 100
    },
}



export default {
    FALLBACK_LANG: FALLBACK_LANG,
    FALLBACK_COUNTRY: FALLBACK_COUNTRY,
    API_URL: API_URL,
    GEOLOCATION_URL: GEOLOCATION_URL,
    LOCATIONS: LOCATIONS,
    INTERVAL_TO_TEXT: INTERVAL_TO_TEXT,
    METHOD_TO_TEXT: METHOD_TO_TEXT,
    RATIO_WARNING: RATIO_WARNING,
    PLANS_LIMITATIONS: PLANS_LIMITATIONS
}